module.exports = __webpack_public_path__ + "img/logo.3beb2a63.svg";